const encodeODataParams = (params = {}) => {
  const output = Object.keys(params).map(key => `$${key}=${encodeURIComponent(params[key])}`);
  return output.join('&');
};

export default encodeODataParams;
//# sourceMappingURL=encodeODataParams.js.map